/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Businesssecondtelefone2Inputs */

const de__field_businesssecondtelefone2 = /** @type {(inputs: _Field_Businesssecondtelefone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zweite Telefonnummer (dienstlich)`)
};

/**

* @param {_Field_Businesssecondtelefone2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_businesssecondtelefone2 = /** @type {((inputs?: _Field_Businesssecondtelefone2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Businesssecondtelefone2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_businesssecondtelefone2(inputs)
});
export { _field_businesssecondtelefone2 as "_field_businessSecondTelefone" }